export interface EscalationContact {
  level: number;
  full_name?: string;
  phone?: string;
  email?: string;
}

/**
 * `relationship_manager.claims_escalation` carries the claims escalation matrix.
 * Level 1 is always present; levels 2 and 3 are optional and any of their fields
 * (phone in particular) can come back null, so empty entries are dropped here and
 * empty fields are skipped while rendering.
 */
export const getClaimEscalationLevels = (relationship_managers: any): EscalationContact[] => {
  const claims_escalation = relationship_managers?.claims_escalation;

  if (!Array.isArray(claims_escalation)) return [];

  return claims_escalation
    .filter((contact: any) => contact?.full_name || contact?.phone || contact?.email)
    .map((contact: any, index: number) => ({
      level: Number(contact?.level) || index + 1,
      full_name: contact?.full_name,
      phone: contact?.phone,
      email: contact?.email,
    }))
    .sort((a: EscalationContact, b: EscalationContact) => a.level - b.level);
};
